module.exports = __webpack_public_path__ + "img/Gallery_1_03.18169486.jpeg";